import { TCocktail } from "@/shared/types";
import { TCocktailDetailTanquerayProps } from "../type";
import { SingleImg } from "@/components/shared/SingleImg";

export function CraftingSetpContainer(props: TCocktailDetailTanquerayProps & { cocktainInfo: TCocktail }) {
    return <div className="crafting-setp-container">
        <div className="title">{props.titleHowToCraft}</div>
        <div className="content-and-img-wrapper">
            <SingleImg className="cocktail-sencend-img" image={props.cocktainInfo.recipeSecondImage} />
            <div className="step-list">
                {
                    props?.cocktainInfo?.method?.map((item, index) => (
                        <div className="step-item" key={index}>
                            <span className="step-number">{index + 1}</span>
                            <div className="step-desc">{item.methodStep}</div>
                        </div>
                    ))
                }
            </div>
        </div>

    </div>
}